{
    "DatePattern": "MMM DD, YYYY",
    "PrettyDatePattern": "Do MMM, YYYY",
    "NAME": "Date"
}